<template>
  <header class="header">
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="nav-logo-container">
          <router-link to="/">
            <img class="d-none d-md-block nav-logo" src="../assets/img/nav-logo.webp" alt="Logo SIHUSEL">
            <img class="d-block d-md-none nav-logo" src="../assets/img/nav-logo-responsive.webp" alt="Logo SIHUSEL">
          </router-link>
        </div>
      </div>
      <div class="col-12 col-md-2 center-content">
        <div class="nav-element"><router-link class=" nav-text" to="/Nosotros">Nuestra Escencia</router-link></div>
      </div>
      <div class="col-12 col-md-2 center-content">
        <div class="nav-element"><router-link class=" nav-text" to="/Creditos">Créditos</router-link></div>
      </div>
      <div class="col-12 col-md-2 center-content">
        <div class="nav-element"><a class=" nav-text" href="/Aviso de Privacidad Acreditados.pdf" target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a></div>
      </div>
      <div class="col-12 col-md-2 center-content">
        <div class="nav-element"><a class=" nav-text" href="/Terminos y Condiciones generales.pdf" target="_blank" rel="noopener noreferrer">Términos y Condiciones</a></div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'NavMenu'
}
</script>

